import axios from "axios";

const ENV_URL = process.env.REACT_APP_BACKEND_URL;
const IS_LOCAL = ["localhost", "127.0.0.1"].includes(window.location.hostname);
export const BACKEND = IS_LOCAL ? ENV_URL : window.location.origin;
export const API = `${BACKEND}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Algo deu errado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
